const sliders = document.querySelectorAll<HTMLElement>('.impact-slider');

if (sliders.length > 0) {
  let scrollAmount = 0;
  const speed = 0.5;
  const contentDuplicates = 3;
  let isVisible = false;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isVisible = entry.isIntersecting;
      });
    },
    { threshold: 0 }
  );

  function animate() {
    sliders.forEach((slider) => {
      observer.observe(slider);

      if (isVisible) {
        scrollAmount += speed;
        if (scrollAmount >= slider.scrollWidth / contentDuplicates) {
          scrollAmount = 0;
        }
        slider.style.transform = `translateX(-${scrollAmount}px)`;
      }
    });

    requestAnimationFrame(animate);
  }

  animate();
}
